export default {
  title: {
    id: 'sav_conversation_order_title_new',
    defaultMessage: 'Order {orderNumber}',
  },
  skeletonsLabel: {
    id: 'asp_action_bar_actions_list_step_loading_skeleton_label',
    defaultMessage: 'Loading',
  },
  openTasksButton: {
    id: 'asp_seller_conversation_summary_open_tasks_button',
    defaultMessage: 'Open tasks',
  },
  nextTaskButton: {
    id: 'asp_seller_conversation_summary_next_task_button',
    defaultMessage: 'Next task',
  },
}
